import React, { useEffect, useState } from 'react';
import './TodosOsDias.css';
import CardPratos from './../CardPratos/CardPratos';
import { getFirestore, getDocs, collection } from 'firebase/firestore';
import { fireBaseApp } from './../../App';

const TodosOsDias = () => {
  const [pratos, setPratos] = useState([]);

  const db = getFirestore(fireBaseApp);
  const cardapioRef = collection(db, 'TodosOsDias');

  const getPratos = async () => {
    const data = await getDocs(cardapioRef);
    const todosOsDias = data.docs.map(doc => doc.data());
    setPratos(todosOsDias);
  };

  useEffect(() => {
    getPratos();
  }, []);

  return (
    <section id="todosOsDias">
      <h2>TODOS OS DIAS</h2>
      <ul>
        {pratos.map((prato, index) => (
          <CardPratos prato={prato} key={`@todosOsDias-${index}`}/>
        ))}
      </ul>
    </section>
  );
};

export default TodosOsDias;
